export const PAYMENT_MODES = {
  CASH_ON_DELIVERY: 'COD',
  PAY_IN_PARTS: 'pay_in_parts',
  PAY_LATER: 'pay_later',
  PAY_OVER_TIME: 'pay_over_time',
  PAYPAL: 'PayPal',
  KLARNA: 'Klarna',
  VIPPS: 'vipps',
  PAY_NOW: 'pay_now',
  SWISH: 'Swish',
  RUPAY: 'Rupay',
  RAZORPAY: 'razorpay',
  RAZORPAY_CARD: 'razorpay_card',
  RAZORPAY_EMI: 'razorpay_cardless_emi',
  RAZORPAY_NETBANKING: 'razorpay_netbanking',
  RAZORPAY_UPI: 'razorpay_upi',
  RAZORPAY_WALLET: 'razorpay_wallet',
  AFTERPAY: 'afterpay',
}

export const CART_ERROR_GROUPS = {
  FAVOURITES: 'FAVOURITES',
  GENERIC: 'GENERIC',
  ONE_CLICK_CHECKOUT: 'ONE_CLICK_CHECKOUT',
  PAYPAL_EXPRESS: 'PAYPAL_EXPRESS',
}

export const CART_LINKS = {
  CUSTOMER_SERVICE: '/customer-service',

  RETURN_AND_REFUND_POLICY: '/return-and-refund-policy.html',

  HAZMAT_MODAL_POLICY: '/transportation-restrictions.modal.html',
  HAZMAT_POLICY: '/transportation-restrictions.html',

  PRIVACY_POLICY: '/privacy-notice.html',
  PAYMENT: '/payment.html',
  PAYMENT_OPTIONS: '/payment-options.html',
  PAYMENT_INFO_MODAL: '/payments-info.modal.html',
}

const PAGE_TRACKING_DATA = {
  category_id: 'CART',
  category_path: 'CART',
  page_id: 'CART',
}

export const CART_TRACKING_EVENTS = {
  pageView: {
    id: 'pageView',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'VIEW_CART',
    },
  },
}
